// Ragadós fejléc: görgetés után összemegy (is-scrolled). Kis hiszterézis, hogy a küszöbnél ne ugráljon.
// data-reveal (termékoldal): lefelé görgetéskor elrejtjük, felfelé görgetéskor visszajön.
(() => {
  const wrapper = document.querySelector('.header-wrapper[data-shrink]');
  if (!wrapper) return;
  const reveal = wrapper.hasAttribute('data-reveal');
  const section = document.getElementById('shopify-section-header');
  let ticking = false;
  let lastY = window.scrollY;
  const update = () => {
    const y = window.scrollY;
    if (y > 60) wrapper.classList.add('is-scrolled');
    else if (y < 10) wrapper.classList.remove('is-scrolled');
    if (reveal && section) {
      const menuOpen = document.body.classList.contains('mega-menu-open') || wrapper.querySelector('details[open]');
      if (y > 200 && y > lastY + 4 && !menuOpen) section.classList.add('emlek-header-hidden');
      else if (y < lastY - 4 || y <= 200) section.classList.remove('emlek-header-hidden');
    }
    lastY = y;
    ticking = false;
  };
  window.addEventListener('scroll', () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }, { passive: true });
  update();
})();
